export const DOMAIN_QUESTIONS = "QUESTIONS";
